module.exports = __webpack_public_path__ + "img/QKC.f3109dd9.svg";